/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { ErrorMessage, FormikHandlers } from 'formik';
import PropTypes from 'prop-types';
import ErrorLabel from '../ErrorLabel';
import { transformLabels } from '../../../../utils/misc';

import styled from 'styled-components';
import { Colors } from '~/src/scss/common/style';

interface Props {
  name: string;
  value: any;
  cols?: number;
  onBlur?: FormikHandlers['handleBlur'];
  onChange: FormikHandlers['handleChange'];
  setFieldValue: any;
  isMulti?: boolean;
  height?: number;
  errorMessage?: any;
}
export default function FileInputComponent({
  name,
  value,
  cols = 6,
  onBlur,
  onChange,
  setFieldValue,
  isMulti = false,
  height = 33,
  errorMessage,
}: Props): JSX.Element {
  const [file, setFile] = useState('No chosen file');
  const displayLogoInfo = (item: string | FileList | null): ReactElement => {
    if (!item || (item && item.length === 0)) {
      return <>No chosen file</>;
    }
    if (item.length === 1) {
      return <Placeholder>{item[0].name}</Placeholder>;
    }
    return (
      <Placeholder>
        {item.length}
        files
      </Placeholder>
    );
  };

  const onHandleChange = (event) => {
    const fileName = event.target.value.split('\\').pop();
    // console.log('fileName', fileName);
    setFile(fileName);
    const { files } = event.target;
    // setFieldValue(name, event.target.files);
  };

  // useEffect(() => {
  //   displayLogoInfo(file);
  // }, [file]);

  return (
    // <StyledInputFile style={{ zIndex: 0 }}>
    <StyledInputFile className={`col-sm-${cols}`} style={{ zIndex: 0 }}>
      <LabelStyle className="ak-form-labels" htmlFor={name}>
        {transformLabels(name)}
      </LabelStyle>
      <div className="custom-file custom-file--row">
        <Input
          onBlur={onBlur}
          // onChange={onChange}
          // value={value}
          height={height}
          onChange={(event) => {
            // var value = isMulti?event.target.files
            setFieldValue(name, event.target.files);
            setFile(event.target.value.split('\\').pop());
            // onChange(event);
          }}
          type="file"
          name={name}
          className="custom-file-input"
        />

        <Label height={height} className="custom-file-label" htmlFor="ak-file-upload-field">
          {file !== '' ? <Placeholder> {file}</Placeholder> : <Placeholder>No chosen file</Placeholder>}
          {/* <Placeholder>{displayLogoInfo(value)}</Placeholder> */}
        </Label>
      </div>
      {console.log('errorMessage', errorMessage)}
      <ErrorMessage name={name}>{(errorMessage) => <ErrorLabel error={errorMessage} />}</ErrorMessage>
    </StyledInputFile>
    // </StyledInputFile>
  );
}

const LabelStyle = styled.label`
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  color: ${Colors.darkBrown};
  text-align: left;
  width: 100%;
  margin-left: 8px;
  margin-bottom: 11px;
`;

const StyledInputFile = styled.div`
  position: relative;
  display: inline-block;
  font-size: 1em;
  width: 100%;
  padding: 0 10px;
  .custom-file-input {
    position: relative;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: 11;
  }

  .custom-file-label {
    border: 1px solid #eeee;
    background: #fff;
    border-radius: 100px;
    display: flex;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .custom-file-label:hover {
    background-color: #eee;
  }
`;

const Input = styled.input`
  position: relative;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  border-radius: 100px;
  border: 1px solid #eee;
  background-color: #fff;
  cursor: pointer;
  height: ${(props) => props.height}px !important;
`;

const Label = styled.label`
  height: ${(props) => props.height}px;
  &:after {
    color: ${Colors.newOrage};
    border-color: ${Colors.newOrage};
    background-color: rgba(239, 125, 0, 0.09);
    border-radius: 100px !important;
    border: 1px solid ${Colors.newOrage};
    width: 103px;
    height: calc(${(props) => props.height}px - 2px);
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Placeholder = styled.span`
  color: #a7a7a7;
  font-size: 14px;
  text-align: left;
  width: 100%;
`;
